import * as React from 'react';
import { useLinkStyles } from '../hooks/useLinkStyles.js';

/**
 * @description The Link component is used for anchor links. By default renders `<a>`,
 * but can be overridden with `as` prop (e.g. `NextLink`)
 *
 * @component
 * @example
 * ```jsx
 * <Link href="#" as={NextLink}>About</Link>
 * ```
 */
const LinkInner = (props, ref) => {
    const { color = 'blue', strong, className, children, as = 'a', ...restProps } = props;
    const classNames = useLinkStyles({ color, strong, className });
    return React.createElement(as, {
        ...restProps,
        className: classNames,
        ref,
    }, children);
};
const Forwarded = React.forwardRef(LinkInner);
const Link = Forwarded;
Forwarded.displayName = 'Link';

export { Link };
//# sourceMappingURL=Link.js.map
